import { Button, Logo } from '../../components/ui';
import { useT, type MessageKey } from '../../i18n';

/** 404, 403 y 500 con la misma cara: es la marca, no un volcado del servidor. */
function ErrorShell({
  code,
  title,
  message,
}: {
  code: string;
  title: MessageKey;
  message: MessageKey;
}) {
  const t = useT();

  return (
    <div className="grid min-h-dvh place-items-center px-4 text-center">
      <div>
        <Logo size="lg" className="flex-col gap-3" />
        <p className="mt-2 text-sm text-muted">{t('common.tagline')}</p>

        <p className="mt-10 bg-brand bg-clip-text text-7xl font-semibold text-transparent">
          {code}
        </p>
        <h1 className="mt-3 text-2xl font-semibold">{t(title)}</h1>
        <p className="mx-auto mt-2 max-w-sm text-muted">{t(message)}</p>

        <div className="mt-8 flex justify-center gap-3">
          <Button to="/">{t('error.goHome')}</Button>
          <Button to="/dashboard" variant="outline">
            {t('nav.dashboard')}
          </Button>
        </div>
      </div>
    </div>
  );
}

export function NotFoundPage() {
  return <ErrorShell code="404" title="error.notFound" message="error.notFoundBody" />;
}

export function ForbiddenPage() {
  return <ErrorShell code="403" title="error.forbidden" message="error.forbiddenBody" />;
}

export function ServerErrorPage() {
  return <ErrorShell code="500" title="error.serverError" message="error.serverErrorBody" />;
}
